<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="$router.back()" />
      </template>
      キャンセルポリシー・注意点
    </Header>

    <CancelPolicyContent>
      <OrderFixedButton
        hasSub
        enabledVariant="primary"
        @click="onClickLastConfirm"
        :abTestGroup3300="abTestGroup3300"
      >
        最終確認へ
        <template #sub>
          ボタンを押すと上記内容を同意することになります
        </template>
      </OrderFixedButton>
    </CancelPolicyContent>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { AbTest3300 } from "@/app/services/AbTestService";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import CancelPolicyContent from "@/components/organisms/order/CancelPolicyContent.vue";
import OrderFixedButton from "@/components/organisms/orders/OrderFixedButton.vue";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import { authStore } from "@/store/auth";

@Component({
  components: {
    FeatherIcon,
    Header,
    OrderFixedButton,
    CancelPolicyContent
  }
})
export default class OrdersCancelPolicy extends Vue {
  get orderId() {
    return this.$route.params["orderId"];
  }
  get workTimeOptionId(): number {
    return Number(this.$route.params["workTimeOptionId"]);
  }
  get abTestGroup3300(): "B" | "C" {
    return AbTest3300.getTestGroup();
  }
  // 理解度テストの実施が必要か
  get needsTest() {
    // 前回キャンセルした勤務日が3日以内の場合、このフラグが true になっているためテストを実施する
    // 値が設定されていないケース（リリース直後や localStorage から値が復元された場合など）はテストを実施しない
    if (authStore.shouldRequireUnderstandingTest === undefined) {
      return false;
    }
    return authStore.shouldRequireUnderstandingTest;
  }

  async onClickLastConfirm() {
    this.$loading.show();
    try {
      sendAdjustEvent("CONFIRM_CANCEL_POLICY");
      sendFirebaseCustomEvent("confirm_cancel_policy", {
        order_id: (this.orderId as string) || "unknown"
      });

      if (this.needsTest) {
        await this.$router.push({
          name: "OrdersUnderstandingTestStart",
          params: {
            orderId: this.orderId.toString(),
            workTimeOptionId: this.workTimeOptionId.toString()
          }
        });
      } else {
        await this.$router.push({
          name: "OrdersLastConfirmation",
          params: {
            orderId: this.orderId.toString(),
            workTimeOptionId: this.workTimeOptionId.toString()
          }
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.$loading.hide();
    }
  }
}
</script>
